<template>
    <div>
        <el-form ref="formRef" :model="form" label-width="150px" :rules="rules">
            <el-form-item label="名称" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="服务类型" prop="serviceType">
                <span>(顺序:研究开发|技术转移|检验检测认证|创业孵化|知识产权|科技咨询|科学技术普及|科技金融|综合科技服务)</span>
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.serviceType">
                </el-input>
            </el-form-item>
            <el-form-item label="入驻机构数" prop="settlementNum">
                <span>(地区顺序:兰州|白银|嘉谷关|金昌|天水|酒泉|张掖|武威|定西|陇南|平凉|庆阳|临夏|甘南|省外|国际)</span>
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.settlementNum">
                </el-input>
            </el-form-item>
            <el-form-item label="机构类型数量" prop="mechanismTypeNum">
                <span>(顺序:高 校|国有企业|科研院所| 民营企业 |事业单位|其 他)</span>
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.mechanismTypeNum">
                </el-input>
            </el-form-item>
            <el-form-item style="display: flex;justify-content: center;margin-left: -150px;">
                <el-button type="primary" @click="onSubmit">修 改</el-button>
                <el-button @click="resetForm">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                title: '',
                serviceType: '',
                settlementNum: '',
                mechanismTypeNum: '',
                id: ''
            },
            rules: {
                title: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                serviceType: [
                    { required: true, message: '请输入服务类型', trigger: 'blur' }
                ],
                settlementNum: [
                    { required: true, message: '请输入入驻机构数', trigger: 'blur' }
                ],
                mechanismTypeNum: [
                    { required: true, message: '请输入机构类型数量', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        onSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    let params = {
                        ...this.form,
                    }
                    this.http.put('apij2/admin-api/voucher/large-screen-service-organization-management/update', params).then((res) => {
                        if (res.data) {
                            this.resetForm()
                            this.$message({
                                message: '编辑成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                message: '请检查表单内容',
                                type: 'warning'
                            });
                        }

                    });
                } else {
                    this.$message({
                        message: '请检查表单内容',
                        type: 'warning'
                    });
                }
            })

        },
        onClose() {
            this.$emit('onClose')
        },
        resetForm() {
            this.$emit('onSubmit')
            this.$refs.formRef.resetFields();
        },
        getData(row) {
            this.form = { ...row }
        }
    }
}   
</script>
<style scoped lang="scss">
span {
    color: #868686;
    font-size: 12px;
}
</style>